var map = {
	"./blue_lagoon_1.png": 85,
	"./blue_lagoon_1_lowdef.png": 86,
	"./blue_lagoon_2.png": 87,
	"./blue_lagoon_2_lowdef.png": 88,
	"./blue_lagoon_3.png": 89,
	"./blue_lagoon_3_lowdef.png": 90,
	"./en_vrai_c@etait_bien_1.png": 91,
	"./en_vrai_c@etait_bien_1_lowdef.png": 92,
	"./en_vrai_c@etait_bien_2.png": 93,
	"./en_vrai_c@etait_bien_2_lowdef.png": 94,
	"./en_vrai_c@etait_bien_3.png": 95,
	"./en_vrai_c@etait_bien_3_lowdef.png": 96,
	"./kiss_the_rail.png": 97,
	"./kiss_the_rail_lowdef.png": 98,
	"./serpentines_1.png": 99,
	"./serpentines_1_lowdef.png": 100,
	"./serpentines_2.png": 101,
	"./serpentines_2_lowdef.png": 102,
	"./serpentines_3.png": 103,
	"./serpentines_3_lowdef.png": 104
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84;